import { cloneDeep } from 'lodash'

import types from '@/store/mutation-types'
import { email, phone } from '@/utils/regex'

/**
 * This store is mainly for user events on front-end,
 * the purpose is to seperate data of back-end from data made on front-end
 */

// This store is for TMS standalone WP's tenancy contractors

// Definition for tenancy contractor attributes
const tenancyContractorAttrs = [
  'id',
  'userId',
  'companyId',
  'userAccount',
  'firstName',
  'lastName',
  'contractorType',
  'companyName',
  'officeTel',
  'mobile',
  'lastLogin',
  'lastInviteDateTime',
  'user',
  'company',
]

const defaultValidation = {
  userAccount: (val) => !val || !!new RegExp(email).exec(val),
  firstName: (val) => !!val,
  lastName: (val) => !!val,
  contractorType: (val) => !!val,
  companyName: (val) => !!val,
  officeTel: null,
  mobile: (val) => !!new RegExp(phone).exec(val),
}

class TenancyContractor {
  constructor (initData = {}) {
    this.validation = {}
    tenancyContractorAttrs.forEach((key) => {
      this[key] = initData[key] || ''
      this.validation[key] = true
    })
    this.id = this.id === '' ? String(Math.random()) : this.id
  }
}

const defaultState = {
  contractors: [],
  contractorsHistory: [],
}

const getters = {
  sawpContractors: state => state.contractors,
  validationResult: (state) => state.contractors.reduce((acc, contractor) => acc && Object.values(contractor.validation).reduce((acc, field) => acc && field, true), true),
}

const mutations = {
  // Set all contractors, usually for init and reload info
  [types.TENANCY_CONTRACTOR_SET_ALL] (state, { contractors }) {
    if (contractors && contractors !== state.contractors) {
      state.contractors = contractors.map((contractor) => new TenancyContractor(contractor))
    }
  },
  // Update one contractor's field
  [types.TENANCY_CONTRACTOR_SET_INFO] (state, { id, key, val }) {
    const stringId = id == null ? id : String(id)
    const contractor = state.contractors.find(
      (item) => {
        if (!item) return false
        if (item.id === id) return true
        return item.id != null && String(item.id) === stringId
      },
    )
    if (!contractor) return
    contractor[key] = val
  },
  // Add a new contractor
  [types.TENANCY_CONTRACTOR_ADD] (state) {
    state.contractors.push(new TenancyContractor())
  },
  // Save the contractors info when starting to edit
  [types.TENANCY_CONTRACTOR_START_EDIT] (state) {
    state.contractorsHistory = cloneDeep(state.contractors)
  },
  // Backtrack the original contractors info when cancelling edit
  [types.TENANCY_CONTRACTOR_CANCEL_EDIT] (state) {
    state.contractors = state.contractorsHistory
  },
  [types.TENANCY_CONTRACTOR_DELETE] (state, { id }) {
    state.contractors.splice(state.contractors.findIndex((contractor) => contractor.id === id), 1)
  },
  [types.TENANCY_CONTRACTOR_VALIDATE] (state, payload = { validation: defaultValidation }) {
    const { validation } = payload
    state.contractors.forEach((contractor) => {
      Object.keys(validation).forEach((field) => {
        contractor.validation[field] = validation[field] ? validation[field](contractor[field]) : true
      })
    })
  },
}

// CAUTION: this store is for editing tenancy contractors only,
// to just get latest tenancy contractors info, call api and extract it from tenancy object directly
export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
}
